import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Layout, Carregando, Aviso } from "./components/Layout";
import { Landing } from "./pages/Landing";
import { Inscricao } from "./pages/Inscricao";
import { Listas } from "./pages/Listas";
import { Impugnacao } from "./pages/Impugnacao";
import { Admin } from "./pages/admin/Admin";
import { Area } from "./pages/candidato/Area";
import { LoginCandidato } from "./pages/candidato/Login";
import { CriarSenha } from "./pages/candidato/CriarSenha";
import { PrimeiroAcesso } from "./pages/candidato/PrimeiroAcesso";
import { EsqueciSenha } from "./pages/candidato/EsqueciSenha";
import { RedefinirSenha } from "./pages/candidato/RedefinirSenha";
import { api, type Edital } from "./lib/api";

/** Páginas únicas sem cabeçalho/rodapé público (admin e área do candidato têm checagem própria acima). */
const ROTAS_SEM_CASCA_PUBLICA = ["/entrar", "/criar-senha",
  "/primeiro-acesso", "/esqueci-senha", "/redefinir-senha"];

export function App() {
  const [edital, setEdital] = useState<Edital | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const local = useLocation();

  useEffect(() => {
    api.get<Edital>("/api/publico/edital")
      .then(setEdital)
      .catch(() => setErro("Não foi possível carregar os dados do edital."));
  }, []);

  // Título da página por rota: leitores de tela anunciam a mudança de contexto.
  useEffect(() => {
    const titulos: Record<string, string> = {
      "/": "Processo Seletivo Simplificado",
      "/inscricao": "Inscrição",
      "/listas": "Listas de classificação",
      "/impugnacao": "Impugnação ao edital",
      "/entrar": "Entrar",
      "/area": "Minha área",
    };
    const base = titulos[local.pathname] ?? "Processo Seletivo Simplificado";
    document.title = `${base} | SEMED Baixo Guandu`;
  }, [local.pathname]);

  // Admin e área do candidato têm roteamento próprio (<Routes> interno). Renderizados
  // direto, fora de qualquer <Routes> deste nível — aninhar <Routes> dentro de
  // <Routes> quebra o casamento de rotas absolutas do React Router.
  if (local.pathname.startsWith("/admin")) {
    return <Admin />;
  }
  if (local.pathname.startsWith("/area")) {
    return <Area />;
  }

  // As demais telas sem casca pública são páginas únicas, sem roteamento próprio.
  if (ROTAS_SEM_CASCA_PUBLICA.some((p) => local.pathname === p || local.pathname.startsWith(p + "/"))) {
    return (
      <Routes>
        <Route path="/entrar" element={<LoginCandidato />} />
        <Route path="/criar-senha" element={<CriarSenha />} />
        <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/redefinir-senha/:token" element={<RedefinirSenha />} />
      </Routes>
    );
  }

  if (erro) {
    return (
      <Layout edital={null}>
        <section className="secao">
          <div className="container container-estreito">
            <Aviso tipo="erro" titulo="Serviço indisponível">{erro}</Aviso>
          </div>
        </section>
      </Layout>
    );
  }

  if (!edital) {
    return <Layout edital={null}><Carregando texto="Carregando o edital" /></Layout>;
  }

  return (
    <Layout edital={edital}>
      <Routes>
        <Route path="/" element={<Landing edital={edital} />} />
        <Route path="/inscricao" element={<Inscricao edital={edital} />} />
        <Route path="/listas" element={<Listas edital={edital} />} />
        <Route path="/impugnacao" element={<Impugnacao edital={edital} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
